import React from 'react';

import { SupportContactFormBlockData } from 'api/cms';
import { AmpHeroBlock } from 'cms/blocks/Amp/AmpHeroBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpSupportContactFormBlock({
  content,
  data,
  blockId,
}: AmpBlockMappingComponentProps<SupportContactFormBlockData>) {
  const text = getText('Need Help?');
  const buttonText = getText('Contact Us');

  return (
    <AmpHeroBlock
      content={content}
      // @ts-expect-error Fix me
      data={{
        ...data,
        text,
        buttonText,
      }}
      blockId={blockId}
    />
  );
}
